/**
 * Product Personalization Handler
 *
 * Shows/hides a personalization text field based on the selected product option.
 * The personalization field is shown when an option containing "Personalisierung"
 * or "mit Personalisierung" is selected.
 */

class ProductPersonalization {
  constructor() {
    this.initializeOnLoad();
  }

  initializeOnLoad() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    // Find all variant selects on the page
    const variantSelects = document.querySelectorAll('variant-selects');

    variantSelects.forEach(variantSelect => {
      this.setupPersonalizationToggle(variantSelect);
    });
  }

  setupPersonalizationToggle(variantSelect) {
    const sectionId = variantSelect.dataset.section;
    const personalizationField = document.getElementById(`personalization-field-${sectionId}`);
    const personalizationInput = document.getElementById(`personalization-text-${sectionId}`);

    if (!personalizationField || !personalizationInput) {
      return;
    }

    // Get all option inputs (radio buttons, dropdowns, etc.)
    const optionInputs = variantSelect.querySelectorAll('input[type="radio"], select');

    // Function to check if personalization should be shown
    const updatePersonalizationVisibility = () => {
      let shouldShow = false;

      // Check all selected options
      optionInputs.forEach(input => {
        let selectedValue = '';

        if (input.type === 'radio' && input.checked) {
          selectedValue = input.value;
        } else if (input.tagName === 'SELECT') {
          selectedValue = input.options[input.selectedIndex]?.text || '';
        }

        // Check if the selected value contains "Personalisierung" or "mit Personalisierung"
        if (selectedValue.toLowerCase().includes('personalisierung')) {
          shouldShow = true;
        }
      });

      // Show or hide the personalization field with smooth transition
      if (shouldShow) {
        personalizationField.style.display = 'block';
        personalizationInput.setAttribute('required', 'required');
        // Smooth fade in
        setTimeout(() => {
          personalizationField.style.opacity = '1';
          personalizationField.style.transform = 'translateY(0)';
        }, 10);
      } else {
        personalizationField.style.opacity = '0';
        personalizationField.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          personalizationField.style.display = 'none';
        }, 200);
        personalizationInput.removeAttribute('required');
        personalizationInput.value = ''; // Clear the field when hidden
      }
    };

    // Add transition styles
    personalizationField.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
    personalizationField.style.opacity = '0';
    personalizationField.style.transform = 'translateY(-10px)';

    // Listen for changes on all option inputs
    optionInputs.forEach(input => {
      input.addEventListener('change', updatePersonalizationVisibility);
    });

    // Initial check on page load
    updatePersonalizationVisibility();

    // Also listen for variant change events (in case variants are changed programmatically)
    variantSelect.addEventListener('variant:change', updatePersonalizationVisibility);
  }
}

// Initialize when the script loads
new ProductPersonalization();
